import { z } from 'zod';
import { portalRoleSchema } from './domain.js';
/** API error codes the web client reacts to. */
export const API_ERROR_CODES = {
    unauthenticated: 'UNAUTHENTICATED',
    noTeam: 'NO_TEAM',
    forbidden: 'FORBIDDEN',
    notFound: 'NOT_FOUND',
    /** A PO-only field (priority, order, retained impact…) sent by a Demandeur or a Référent. */
    poOnlyField: 'PO_ONLY_FIELD',
    /** Product unknown, inactive, or not accessible to the user's team. */
    productNotAllowed: 'PRODUCT_NOT_ALLOWED',
    /** A request entered for someone else by a role other than PO (ADR-004). */
    onBehalfForbidden: 'ON_BEHALF_FORBIDDEN',
    /** The requester of the request has no team that may own it. */
    noEligibleTeam: 'NO_ELIGIBLE_TEAM',
    /** A request without product cannot become « Qualifiée » or later (ADR-003). */
    productRequired: 'PRODUCT_REQUIRED',
    /** The Jira connector is not configured in this environment. */
    jiraUnavailable: 'JIRA_UNAVAILABLE',
    /** A version targeted by requests or carrying a release note cannot be deleted (ADR-012). */
    versionInUse: 'VERSION_IN_USE',
};
export const apiErrorSchema = z.object({
    code: z.string(),
    message: z.string(),
});
export const sessionTeamSchema = z.object({
    id: z.uuid(),
    name: z.string(),
});
/** Payload of GET /api/session. Contains no token of any kind. */
export const sessionSchema = z.object({
    user: z.object({
        id: z.uuid(),
        email: z.string(),
        firstName: z.string(),
        lastName: z.string(),
    }),
    role: portalRoleSchema,
    teams: z.array(sessionTeamSchema),
    hasTeam: z.boolean(),
    /** True for a Demandeur or a Référent without team: « Accès refusé ». A PO without team is let in (ADR-005 §1). */
    deniedForNoTeam: z.boolean(),
    /** « Camille Se. » / « Camille St. »: short names of the people who share « Prénom I. », by user id. */
    shortNames: z.record(z.string(), z.string()).default({}),
});
/** Payload of GET /api/auth/dev/users (development login provider only). */
export const devLoginUserSchema = z.object({
    id: z.uuid(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    teams: z.array(z.string()),
    lastSeenRoles: z.array(z.string()),
});
export const devLoginBodySchema = z.object({
    userId: z.uuid(),
    /** Raw Entra app-role values, run through the same mapping as a real token. */
    entraRoles: z.array(z.string()).max(10),
});
/** Spaces of the portal. Product and admin are PO-only. */
export const SPACES = ['business', 'product', 'admin'];
//# sourceMappingURL=session.js.map